import { render, staticRenderFns } from "./StudentWarnList.vue?vue&type=template&id=7c41c102&scoped=true"
import script from "./StudentWarnList.vue?vue&type=script&lang=js"
export * from "./StudentWarnList.vue?vue&type=script&lang=js"
import style0 from "./StudentWarnList.vue?vue&type=style&index=0&id=7c41c102&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c41c102",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c41c102')) {
      api.createRecord('7c41c102', component.options)
    } else {
      api.reload('7c41c102', component.options)
    }
    module.hot.accept("./StudentWarnList.vue?vue&type=template&id=7c41c102&scoped=true", function () {
      api.rerender('7c41c102', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/statistic/StudentWarnList.vue"
export default component.exports